"use client";

import type { CSSProperties } from "react";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

export function CertificationsSkeleton() {
  return (
    <div className="flex flex-col">
      <SkeletonBar className="h-[52px] w-full !rounded-t-md !rounded-b-none" />
      <div className="flex gap-2.5 rounded-b-md border border-border bg-surface-elevated p-5">
        <SkeletonBar className="size-[42px] !rounded-md shrink-0" />
        <div className="flex-1 min-w-0 flex flex-col gap-1.5">
          <SkeletonBar className="h-3.5 w-[130px]" />
          <SkeletonBar className="h-[13px] w-[70%]" />
        </div>
      </div>
    </div>
  );
}
